import { useState } from 'react';
import MDBox from 'src/components/md/MDBox';
import MDButton from 'src/components/md/MDButton';
import MDTypography from 'src/components/md/MDTypography';
import Modal from 'src/components/modal/Modal';
import { useTriggerRefetchAllData } from 'src/api/core/useTriggerRefetchAllData';
import { useToast } from 'src/context/ToastContext';

function FamousConfigCard() {
  const [showWarningModal, setShowWarningModal] = useState(false);
  const { showToast } = useToast();

  const triggerRefetch = useTriggerRefetchAllData(undefined, (error) => {
    showToast({
      title: 'Error',
      message: error.message,
      color: 'error',
      icon: 'error',
    });
  });

  const handleTriggerSync = () => {
    setShowWarningModal(true);
  };

  const handleCancelFullSync = () => {
    setShowWarningModal(false);
  };

  const handleConfirmFullSync = () => {
    triggerRefetch.mutate();
    setShowWarningModal(false);
  };

  return (
    <>
      <MDBox p={3}>
        <MDTypography variant="h6" fontWeight="medium" mb={3}>
          Data Refresh
        </MDTypography>

        <MDTypography variant="body2" color="text.secondary" mb={3}>
          Manually trigger a comprehensive data refresh from all integrated
          systems. This operation can only be performed once every 2 hours.
        </MDTypography>

        <MDButton
          variant="contained"
          color="primary"
          onClick={handleTriggerSync}
          disabled={triggerRefetch.isLoading}
        >
          {triggerRefetch.isLoading
            ? 'Triggering Data Refresh...'
            : 'Trigger Data Refresh'}
        </MDButton>
      </MDBox>

      <Modal
        open={showWarningModal}
        title="Data Refresh Warning"
        onCloseButton={{
          text: 'Cancel',
          onClick: handleCancelFullSync,
        }}
        onConfirmButton={{
          text: 'Proceed with Data Refresh',
          onClick: handleConfirmFullSync,
          color: 'warning',
          variant: 'contained',
          disabled: triggerRefetch.isLoading,
        }}
        closeable
      >
        <MDBox p={3}>
          <MDTypography variant="body1" mb={2}>
            ⚠️ Warning: Data refresh can only be triggered once every 2 hours.
          </MDTypography>
          <MDTypography variant="body2" color="text.secondary">
            This operation will trigger a full data refresh from Famous, which
            can take several hours to complete. It will cancel any existing pull
            and restart. Are you sure you want to proceed?
          </MDTypography>
        </MDBox>
      </Modal>
    </>
  );
}

export default FamousConfigCard;
